import { t } from "@lingui/macro";
import { axios } from "@/client/libs/axios";
import { ChangeToneDto, TextDto, Mood } from "@reactive-resume/dto";
import type { AxiosResponse, AxiosError } from "axios";

const callOpenAiEndpoint = async <T>(endpoint: string, data: T): Promise<string> => {
  try {
    const response = await axios.post<T, AxiosResponse<{ content: string }>>(
      `/openai/${endpoint}`,
      data
    );
    return response.data.content;
  } catch (error) {
    const axiosError = error as AxiosError;
    const errorMessage = axiosError?.status === 429
      ? t`OpenAI rate limit exceeded. Please try again later.`
      : t`OpenAI did not return any choices for your text.`;
    throw new Error(errorMessage);
  }
};

export const changeTone = async (text: string, mood: Mood): Promise<string> => {
  return callOpenAiEndpoint<ChangeToneDto>("change-tone", { text, mood });
};

export const fixGrammar = async (text: string): Promise<string> => {
  return callOpenAiEndpoint<TextDto>("fix-grammar", { text });
};

export const improveWriting = async (text: string): Promise<string> => {
  return callOpenAiEndpoint<TextDto>("improve-writing", { text });
};
